import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "slottimeselection",
    "slottimeselectiontest",
    "zonesselection",
    "slotVehicleId",
    "slotDaysInput",
    "premiumInstructorId",
    "errorMessageContainer",
    "errorMessage",
    "loader",
    "formButtons",
    "successContainer",
    "testRadioButton",
    "testRadioButton",
    "slotsSectionContainer",
    "slotsSectionContainerTest",
    "observationContainer",
    "observableCheckbox",

    "programsContainer",
    "programCheckboxes",
    "teenCheckbox",
    "adultCheckbox",
  ];

  apiErrors = [];
  changedElements = [];

  connect() { }

  validateForm(event) {
    const errors = [];

    this.changedElements.push(event.currentTarget);

    const allowsTeen = this.teenCheckboxTarget.checked;
    const allowsAdult = this.adultCheckboxTarget.checked;
    // Any program must be selected if neither teen nor adult only is selected
    let programSelected = false;
    this.programCheckboxesTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        programSelected = true;
      }
    });
    if (!allowsTeen && !allowsAdult && !programSelected) {
      errors.push("Please select at least one program");
    }

    const isTestSelected = this.testRadioButtonTarget.checked;
    if (isTestSelected) {
      this.slotsSectionContainerTarget.classList.add("u-hidden");
      this.slotsSectionContainerTestTarget.classList.remove("u-hidden");
      this.observationContainerTarget.classList.add("u-hidden");
      if (this.changedElements.includes(this.slottimeselectiontestTarget)) {
        try {
          const slotTimesValue = JSON.parse(
            this.slottimeselectiontestTarget.value
          );
          if (slotTimesValue.length === 0) {
            errors.push("Please select at least one slot time");
          }
        } catch { }
      }
    } else {
      this.slotsSectionContainerTarget.classList.remove("u-hidden");
      this.slotsSectionContainerTestTarget.classList.add("u-hidden");
      this.observationContainerTarget.classList.remove("u-hidden");
      if (this.changedElements.includes(this.slottimeselectionTarget)) {
        try {
          const slotTimesValue = JSON.parse(this.slottimeselectionTarget.value);
          if (slotTimesValue.length === 0) {
            errors.push("Please select at least one slot time");
          }
        } catch { }
      }
    }

    if (this.changedElements.includes(this.zonesselectionTarget)) {
      try {
        const zonesValue = JSON.parse(this.zonesselectionTarget.value);
        if (zonesValue.length === 0) {
          errors.push("Please select at least one zone");
        }
      } catch { }
    }

    if (this.changedElements.includes(this.slotVehicleIdTarget)) {
      try {
        const slotVehicleIdValue = this.slotVehicleIdTarget.value;
        if (slotVehicleIdValue === "") {
          errors.push("Please select a vehicle");
        }
      } catch { }
    }

    if (this.changedElements.includes(this.slotDaysInputTarget)) {
      try {
        const slotDaysValue = JSON.parse(this.slotDaysInputTarget.value);
        if (slotDaysValue.length === 0) {
          errors.push("Please select at least one day");
        }
      } catch { }
    }

    errors.push(...this.apiErrors);

    if (errors.length > 0) {
      this.errorMessageContainerTarget.classList.remove("u-hidden");
    } else {
      this.errorMessageContainerTarget.classList.add("u-hidden");
    }

    this.errorMessageTarget.innerHTML = "";
    errors.forEach((error) => {
      // Create a new p element
      const p = document.createElement("p");
      p.innerHTML = error;
      this.errorMessageTarget.appendChild(p);
    });

    return errors;
  }

  closeQuickLook(event) {
    event.preventDefault();
    const quickViewElement = document.querySelector(
      "#school-shifts-quick-look"
    );
    quickViewElement.classList.add("u-hidden");
  }

  success() {
    this.loaderTarget.classList.add("u-hidden");
    this.formButtonsTarget.classList.add("u-hidden");
    this.successContainerTarget.classList.remove("u-hidden");
  }

  beginLoading() {
    this.loaderTarget.classList.remove("u-hidden");
    this.formButtonsTarget.classList.add("u-hidden");
  }

  endLoading() {
    this.loaderTarget.classList.add("u-hidden");
    this.formButtonsTarget.classList.remove("u-hidden");
  }

  async savePattern(event) {
    this.beginLoading();
    this.apiErrors = [];

    // Add all the elements to the changed elements array
    this.changedElements.push(
      this.slottimeselectionTarget,
      this.slottimeselectiontestTarget,
      this.zonesselectionTarget,
      this.slotVehicleIdTarget,
      this.slotDaysInputTarget
    );
    const validationErrors = this.validateForm(event);

    if (validationErrors.length > 0) {
      this.endLoading();
      return;
    }

    const authenticity_token = document.querySelector(
      'meta[name="csrf-token"]'
    ).content;

    const isTest = this.testRadioButtonTarget.checked;
    const premium_instructor_id = this.premiumInstructorIdTarget.value;
    const slottimeselection = isTest
      ? this.slottimeselectiontestTarget.value
      : this.slottimeselectionTarget.value;
    const slottimeselectiontest = this.slottimeselectiontestTarget.value;
    const zonesselection = this.zonesselectionTarget.value;
    const slot_vehicle_id = this.slotVehicleIdTarget.value;
    const slot_days_input = this.slotDaysInputTarget.value;
    const isDrivingTest = this.testRadioButtonTarget.checked;
    const editId = event.currentTarget.dataset.editId;
    const teenAllowed = this.teenCheckboxTarget.checked;
    const adultAllowed = this.adultCheckboxTarget.checked;
    const observable = !isTest && this.observableCheckboxTarget.checked;
    const programs = [];
    this.programCheckboxesTargets.forEach((checkbox) => {
      try {
        if (checkbox.checked) {
          const programIdAsInt = parseInt(checkbox.value, 10);
          programs.push(programIdAsInt);
        }
      } catch {
        // do nothing
      }
    });

    const data = {
      premium_instructor_id,
      slottimeselection,
      zonesselection,
      slot_vehicle_id,
      slot_days_input,
      authenticity_token,
      editId,
      isDrivingTest,
      observable,
      programs,
      teenAllowed,
      adultAllowed,
    };

    console.log(data);

    try {
      const result = await fetch("/schools/setup/shifts/flexible/new", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (result.ok) {
        this.endLoading();
        this.success();
      } else {
        this.endLoading();
        this.apiErrors.push(
          "There was an error saving, please try again later"
        );
        this.validateForm(event);
      }
    } catch (error) {
      this.endLoading();
      this.apiErrors.push("There was an error saving, please try again later");
      this.validateForm(event);
    }
  }

  async removePattern(event) {
    this.beginLoading();
    this.apiErrors = [];
    this.validateForm(event);

    const authenticity_token = document.querySelector(
      'meta[name="csrf-token"]'
    ).content;
    const idToDelete = event.currentTarget.dataset.deleteId;
    const premium_instructor_id = this.premiumInstructorIdTarget.value;

    const data = {
      id: idToDelete,
      authenticity_token,
      premium_instructor_id,
    };

    try {
      const result = await fetch("/schools/setup/shifts/flexible/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (result.ok) {
        this.endLoading();
        this.success();
      } else {
        this.endLoading();
        this.apiErrors.push(
          "There was an error removing, please try again later"
        );
        this.validateForm(event);
      }
    } catch (error) {
      this.endLoading();
      this.apiErrors.push(
        "There was an error removing, please try again later"
      );
      this.validateForm(event);
    }
  }
}
